import type { VersionId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { State } from '../../../../common/types';

export const getFixVersion = (state: State): VersionId[] | null | undefined =>
	state.filters ? state.filters.VERSION : null;
